export default __webpack_public_path__ + "static/media/22-SoundTrack Your Brand-Black.01a86127.png";